import { useMutation } from '@tanstack/react-query';
import { Button } from 'components/ui/button';
import { useOrder } from 'hooks/api/scheduling/useOrder';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';
import CancelItemModal, { Ref as CancelItemModalRef } from './CancelItemModal';
import * as S from './styles';

interface Props {
  clients: any[];
  items: any[];
  onUpdate?: () => void;
}

const OrderClients: React.FC<Props> = ({ clients, items, onUpdate }) => {
  const [clientsState, setClientsState] = useState<any[]>(clients);
  const [selectedClients, setSelectedClients] = useState<Set<number>>(
    new Set()
  );
  const [selectedClientsItems, setSelectedClientsItems] = useState<any[]>([]);
  const cancelItemModalRef = useRef<CancelItemModalRef>(null);

  useEffect(() => {
    setClientsState(clients);
  }, [clients]);

  const { cancelOrderItems } = useOrder();

  const { mutate: itemMutation, isPending: isUpdating } = useMutation({
    mutationFn: (items: any) => cancelOrderItems(items),
    onSuccess: (data: any) => {
      toast('Itens cancelados com sucesso');
      onUpdate?.();
    },
    onError: (error: any) => {
      toast('Erro ao cancelar items', {
        description: error.response.data.message,
      });
    },
  });

  useEffect(() => {
    const clientItems = items.filter((item) =>
      selectedClients.has(item.companyId)
    );
    setSelectedClientsItems(clientItems.map((item) => item.id));
  }, [selectedClients, items]);

  const toggleItemSelection = (itemId: number) => {
    setSelectedClients((prevSelected) => {
      const newSelected = new Set(prevSelected);
      if (newSelected.has(itemId)) {
        newSelected.delete(itemId);
      } else {
        newSelected.add(itemId);
      }
      return newSelected;
    });
  };

  const handleModalCancelOpen = (ids: number[]) => {
    //deve sempre existir pelo menos um cliente no pedido
    if (clientsState.length === selectedClients.size) {
      toast('O pedido deve ficar com pelo menos um cliente.');
      return;
    }

    cancelItemModalRef.current?.openModal();
  };

  return (
    <>
      <CancelItemModal
        ids={Array.from(selectedClientsItems) || ([] as number[])}
        ref={cancelItemModalRef}
        onUpdate={onUpdate}
      />

      <S.List>
        <S.ListHeader>
          <S.Column></S.Column>
          <S.Column>Id</S.Column>
          <S.Column>Nome</S.Column>
          <S.Column>Documento</S.Column>
          <S.Column>IE</S.Column>
        </S.ListHeader>
        {clientsState.map((item) => (
          <S.ListItem key={item.id}>
            <S.Column>
              <input
                type="checkbox"
                checked={selectedClients.has(item.id)}
                onChange={() => toggleItemSelection(item.id)}
              />
            </S.Column>
            <S.Column>{item.id}</S.Column>
            <S.Column>
              {item.tradeName} - {item.addressComplement}
            </S.Column>
            <S.Column>{item.document}</S.Column>
            <S.Column>{item.ie}</S.Column>
          </S.ListItem>
        ))}
      </S.List>
      <div>
        <Button
          onClick={() => handleModalCancelOpen(Array.from(selectedClients))}
          size="sm"
          variant="destructive"
          disabled={selectedClients.size === 0 || isUpdating}
        >
          Cancelar items
        </Button>
      </div>
    </>
  );
};

export default OrderClients;
